import React, { useEffect } from 'react';
import { HeroSection } from './components/HeroSection';
import { EmpathySection } from './components/EmpathySection';
import { ProtocolSection } from './components/ProtocolSection';
import { LifestyleSection } from './components/LifestyleSection';
import { BioFeedbackSection } from './components/BioFeedbackSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { initMetaPixel, trackPageView } from './utils/metaPixel';
export function App() {
  // Initialize Meta Pixel and track PageView
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  // Smooth scroll behavior
  useEffect(() => {
    document.documentElement.style.scrollBehavior = 'smooth';
    return () => {
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);
  return <div className="min-h-screen bg-white text-[#1F2937] font-sans selection:bg-[#F97316] selection:text-white" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <EmpathySection data-id="element-3" />
        <ProtocolSection data-id="element-4" />
        <LifestyleSection data-id="element-5" />
        <BioFeedbackSection data-id="element-6" />
        <TestimonialsSection data-id="element-7" />
        <GuaranteeSection data-id="element-8" />
        <FinalCTA data-id="element-9" />
        <FAQSection data-id="element-10" />
      </main>

      <Footer data-id="element-11" />
    </div>;
}